function base64toBlob(base64: string, type = 'image/png') {
  const byteCharacters = atob(base64.replace(`data:${type};base64,`, ''));
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  return new Blob([byteArray], {type});
}

export default base64toBlob;
